"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var style_value_types_1 = require("style-value-types");

var valueTypes = {
  color: style_value_types_1.color,
  backgroundColor: style_value_types_1.color,
  outlineColor: style_value_types_1.color,
  fill: style_value_types_1.color,
  stroke: style_value_types_1.color,
  borderColor: style_value_types_1.color,
  borderTopColor: style_value_types_1.color,
  borderRightColor: style_value_types_1.color,
  borderBottomColor: style_value_types_1.color,
  borderLeftColor: style_value_types_1.color,
  borderRadius: style_value_types_1.px,
  width: style_value_types_1.px,
  maxWidth: style_value_types_1.px,
  height: style_value_types_1.px,
  maxHeight: style_value_types_1.px,
  top: style_value_types_1.px,
  left: style_value_types_1.px,
  bottom: style_value_types_1.px,
  right: style_value_types_1.px,
  rotate: style_value_types_1.degrees,
  rotateX: style_value_types_1.degrees,
  rotateY: style_value_types_1.degrees,
  rotateZ: style_value_types_1.degrees,
  scale: style_value_types_1.scale,
  scaleX: style_value_types_1.scale,
  scaleY: style_value_types_1.scale,
  scaleZ: style_value_types_1.scale,
  skewX: style_value_types_1.degrees,
  skewY: style_value_types_1.degrees,
  distance: style_value_types_1.px,
  translateX: style_value_types_1.px,
  translateY: style_value_types_1.px,
  translateZ: style_value_types_1.px,
  perspective: style_value_types_1.px,
  opacity: style_value_types_1.alpha,
  transformOriginX: style_value_types_1.percent,
  transformOriginY: style_value_types_1.percent,
  transformOriginZ: style_value_types_1.px
};

exports.default = function (key) {
  return valueTypes[key];
};